import { useEffect, useCallback, useMemo } from 'react';
import { SplitBillService } from 'services/split-bill-service';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useAsyncError } from 'utils/hooks';
import { SESSION } from 'constants/enum/session';

interface Params {
  token: string;
}

const useViewModel = () => {
  const { token } = useParams<Params>();
  const paymentUrl = process.env.NX_PAYMENT_FRONTEND_URL || 'http://localhost:3001';
  const { push } = useHistory();
  const throwError = useAsyncError();

  const splitBillService = useMemo(() => {
    return new SplitBillService();
  }, []);

  const handleChildPayment = useCallback(() => {
    token &&
      splitBillService
        .getChildSplitToken(token)
        .then((item) => {
          sessionStorage?.setItem(SESSION.HEAD_SPLIT_TOKEN, token);
          const url = `${paymentUrl}/${item.token}`;
          return (window.location.href = url);
        })
        .catch((error) => {
          const { statusCode } = error;
          if (statusCode === 403) {
            push(`/404/full-access`);
          } else {
            throwError();
          }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentUrl, push, splitBillService, token]);

  useEffect(() => {
    handleChildPayment();
  }, [handleChildPayment]);

  return null;
};

export default useViewModel;
